module.exports = __webpack_public_path__ + "static/media/74.7d53b550.webp";